export default "__VITE_ASSET__C48cqdZY__$_?url__"